<template>
  <tr id="table-row-component">
    <td><fa-icon :icon="['fas','circle']" :class="statusClass(item.date)" :title="status(item.date)"></fa-icon></td>
    <td><button class="btn btn-link p-0 text-left" v-on:click="selectItem">{{item.theme}}</button></td>
    <td><button class="btn btn-link p-0 text-left" v-on:click="selectItem">{{item.type}}</button></td>
    <td><button class="btn btn-link p-0 text-left" v-on:click="selectItem">{{item.tables.join(', ')}}</button></td>
    <td><button class="btn btn-link p-0 text-left" v-on:click="selectItem">{{item.date | convertDate}}</button></td>
    <td><button class="btn btn-link p-0 text-left" v-on:click="selectItem">{{item.language}}</button></td>
    <td>
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary btn-sm mr-2" v-on:click="duplicate(item)" v-b-tooltip.hover title="Duplizieren"><fa-icon :icon="['fad','clone']" /></button>
        <button class="btn btn-danger btn-sm" v-on:click="deleteFromDatabase" v-b-tooltip.hover title="Löschen"><fa-icon :icon="['fas','trash']" /></button>
      </div>
    </td>
  </tr>
</template>

<script>
import moment from 'moment-timezone'

import { db } from "../plugins/firebase"
import { ref, remove, set, push, child } from "firebase/database"

import { store } from "../plugins/store"

export default {
  name: 'EventRowComponent',
  props: {
    item: Object,
    itemKey: String
  },
  methods: {
    selectItem: function() {
      this.$emit('selectedItem', {
        item: this.item,
        key: this.itemKey
      })
    },
    deleteFromDatabase: function() {
      this.$bvModal.msgBoxConfirm(`Möchtest du "${this.item.theme}" wirklich löschen?`, {
        title: '',
        okVariant: 'danger',
        okTitle: 'OK',
        cancelTitle: 'Abbrechen',
        size: 'sm',
        contentClass: 'shadow',
        hideHeaderClose: false,
        noCloseOnBackdrop: true
      })
      .then(value => {
        if (value === true) {
          remove(ref(db, 'events/' + this.itemKey))
          .catch((error) => {
          store.dispatch("fetchAlert", {
            kind: 'danger',
            message: error,
            time: false
          })
        }) // eslint-disable-line no-console
        }
      })
      .catch((error) => {
          store.dispatch("fetchAlert", {
            kind: 'danger',
            message: error,
            time: false
          })
        }) // eslint-disable-line no-console
    },
    duplicate: function(document) {
      document.theme += ' - Kopie'
      const newPostKey = push(child(ref(db), 'events')).key;
      set(ref(db, 'events/'+newPostKey), document)
      .catch((error) => {
          store.dispatch("fetchAlert", {
            kind: 'danger',
            message: error,
            time: false
          })
        })
    },
    statusClass: function(date) {
      const nowTimestamp = moment(moment().tz('Europe/Berlin').format('YYYY-MM-DD')).unix()
      const dateTimestamp = moment(date).unix()

      return dateTimestamp >= nowTimestamp ? 'text-success' : 'text-secondary'
    },
    status: function(date) {
      const nowTimestamp = moment(moment().tz('Europe/Berlin').format('YYYY-MM-DD')).unix()
      const dateTimestamp = moment(date).unix()

      return dateTimestamp < nowTimestamp ? 'Aktiv' : 'Inaktiv'
    },
  }
}
</script>

<style scoped>
#table-row-component td:first-of-type {
  width: 40px;
}
</style>